import { TfiClose } from "react-icons/tfi";

export default function CrossIcon({ size }) {
    return (
        <TfiClose size={size} />
    );
}